import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-ssc-qianer',
  templateUrl: './ssc-qianer.component.html',
  styleUrls: ['./ssc-qianer.component.css']
})
export class SscQianerComponent implements OnInit {

  @ViewChild('QianErTrendLine') qianer_trend_line_ref: ElementRef;

  @Input()
  public auxs: Array<any>;

  @Input()
  public issue_num: string;

  @Input()
  public trend_data: Array<any>;

  @Input()
  public analysis_data: Array<any>;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.draw_qianer_trend_line_handler();
  }

  // 前二走势线
  public draw_qianer_trend_line_handler() {
    // 设置canvas高度
    this.qianer_trend_line_ref.nativeElement.width = 440;
    this.qianer_trend_line_ref.nativeElement.height = this.trend_data.length * 30;

    const qianer_cxt: CanvasRenderingContext2D = this.qianer_trend_line_ref.nativeElement.getContext('2d');

    let w: number = 440;
    let h: number = this.trend_data.length * 30;
    qianer_cxt.fillStyle = 'rgba(255, 255, 255, 0)';
    qianer_cxt.clearRect(0, 0, w, Number(this.issue_num) * 30);
    qianer_cxt.fillRect(0, 0, w, h);

    for (let i = 0; i < 2; i++) {
      qianer_cxt.beginPath();

      for (let j = 0; j < this.trend_data.length - 1; j++) {
        let win_num_1 = Number(this.trend_data[j].lottery[i]);
        let win_num_2 = Number(this.trend_data[j + 1].lottery[i]);

        let cell_w = 22;
        let cell_h = 30;

        let x1: number = (cell_w * 10 * i) + Number(win_num_1) * cell_w + cell_w / 2;
        let y1: number = (j * cell_h) + cell_h / 2;

        let x2: number = (cell_w * 10 * i) + Number(win_num_2) * cell_w + cell_w / 2;
        let y2: number = ((j + 1) * cell_h) + cell_h / 2;

        qianer_cxt.lineWidth = 1;
        qianer_cxt.strokeStyle = '#FF5656';

        qianer_cxt.moveTo(x1, y1);
        qianer_cxt.lineTo(x2, y2);
        qianer_cxt.stroke();
      }

      qianer_cxt.closePath();
    }
  }

}
